import { render, staticRenderFns } from "./PermittedFunctionList.vue?vue&type=template&id=a5d92d7c&scoped=true&lang=pug"
import script from "./PermittedFunctionList.vue?vue&type=script&lang=ts"
export * from "./PermittedFunctionList.vue?vue&type=script&lang=ts"
import style0 from "./PermittedFunctionList.vue?vue&type=style&index=0&id=a5d92d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d92d7c",
  null
  
)

export default component.exports